import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const topRow = css({
  paddingTop: theme.spacing(1),
});
